import { render, staticRenderFns } from "./ContactMar.vue?vue&type=template&id=481e009b&"
import script from "./ContactMar.vue?vue&type=script&lang=js&"
export * from "./ContactMar.vue?vue&type=script&lang=js&"
import style0 from "./ContactMar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports